import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
import { parseEntityItem } from './getGlobalEntityQueue'

export const parseDate = (input: any, format = undefined) => {
  // Check if input is a string and matches the yyyy-mm-dd format
  if (typeof input === 'string') {
    // Convert the string to a Date object
    if (!format) {
      const date = new Date(input)
      // Check if the date is valid
      if (!isNaN(date.getTime())) {
        return date.toString()
      }
    } else if (format === 'dd-mm-yyyy') {
      const dateArray = input.split('-').map(Number)
      if (dateArray.length != 3) {
        return ''
      }
      const [day, month, year] = dateArray

      // Adjust month as JavaScript months are 0-indexed (0 for January, 11 for December)
      return new Date(year, month - 1, day)
    }
  }

  // Return null or any other default value for invalid dates
  return ''
}

const responseParser = (response: any, ddData: any, userType: any) => {
  const item = isSuccessResponse(response)
  console.log('htahj, mdata=', item)
  return userType === 'RISK_MAKER_SEARCH_ENTITY_NON_EDITABLE' ? item?.merchant : parseEntityItem(item, ddData, '')
}

export const fetchEosEntityDetails = (merchantEntityId: string, ddData: any, userType) => {
  console.log('merchantEntityId', merchantEntityId)
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.eosEntityDetails),
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens),
    headers: getHeaders(),
    body: {
      merchantEntityId,
      ...(userType === 'RISK_MAKER_SEARCH_ENTITY_NON_EDITABLE'
        ? {
            ignoreEditInProgress: true,
          }
        : {}),
    },
  }

  return executeRequest(request)
    .then((response) => responseParser(response, ddData, userType))
    .catch((error) => {
      throw error
    })
}
